import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { EmbeddedVideo } from '#src/app/shared/components/embeddedMedia';

type YouTubeEmbedProps = {
	src: string;
	title: string;
};

const YoutubeEmbed: React.FC<YouTubeEmbedProps> = ({ src, title }) => {
	const html = `<iframe
			src="${src}"
			title="${title}"
			frameBorder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
			allowFullScreen
		/>`;
	return <EmbeddedVideo embedHtml={html} aspectRatio="16/9" />;
};

export const TitleSection: React.FC = () => {
	return (
		<>
			<div className="bg-gradient-background-light-1 h-[150px] md:h-[600px]">
				<div className="container h-full px-2 md:px-4">
					{/* eslint-disable-next-line @change-ds/ds-no-arbitrary-spacing-classname */}
					<div className="flex h-full w-full flex-col items-center justify-center pb-0 md:pb-[380px]">
						<Text variant="heading" as="h1" className="text-center" size="x-large">
							Change.org Racial Justice Fund
						</Text>
					</div>
				</div>
			</div>
			<div className="md:mt-[-380px]">
				<div className="container px-0 md:px-4">
					<div className="aspect-video">
						<YoutubeEmbed
							src="https://www.youtube-nocookie.com/embed/qlfJPMlAx5M"
							title="Change.org Racial Justice Fund Information Video"
						></YoutubeEmbed>
					</div>
				</div>
			</div>
		</>
	);
};
